module.exports = __webpack_public_path__ + "5867e520f74f1ae82470623dca73d07f.jpg";